import lightImg from 'assets/img/spot-illustrations/1.png';
import { useAppDispatch } from 'redux/store';
import darkImg from 'assets/img/spot-illustrations/dark_1.png';
import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

import { signOut } from '../../../redux/slices/authThunk';

const SignOutForm = ({ layout }: { layout: 'simple' | 'card' | 'split' }) => {
  // localStorage.removeItem('user')
  // localStorage.removeItem('token')
  const dispatch = useAppDispatch();
  dispatch(signOut());

  return (
    <div className="text-center mb-6 mx-auto">
      {/* <img className="mb-7 d-dark-none" src={lightImg} alt="phoenix" />
      <img className="mb-7 d-light-none" src={darkImg} alt="phoenix" /> */}
      <div className="mb-6">
        <h4 className="text-1000">Logged off</h4>
        <p className="text-700">
          Thanks for using{' '}
          <a href={import.meta.env.BASE_URL} target="_blank" rel="noreferrer">
            {import.meta.env.VITE_COMPANY_NAME}
          </a>
          &copy; {import.meta.env.VITE_NAME}. <br className="d-lg-none" />
          <span className="d-none d-sm-inline-block" />
          <br />
          <br />
          You are now successfully signed out.
        </p>
      </div>
      <div className="d-grid">
        <Button variant="primary" as={Link} to={`/login`} startIcon={<FontAwesomeIcon icon={faAngleLeft} className="me-2" />}>
          Go to sign in page
        </Button>
      </div>
    </div>
  );
};

export default SignOutForm;
